import LegalLayout, { COMPANY } from "./LegalLayout";

export default function KullanimKosullari() {
  return (
    <LegalLayout eyebrow="Sözleşme" title="Kullanım Koşulları" updated="19 Şubat 2026">
      <p>
        İşbu Kullanım Koşulları ({COMPANY.brand} — bundan sonra <strong>"Hizmet"</strong>), <strong>{COMPANY.legalName}</strong>
        ({COMPANY.address}) tarafından işletilen web tabanlı kuyumcu yönetim platformunun kullanımına ilişkin
        kural ve şartları düzenler. Hizmet'e üye olarak veya Hizmet'i kullanarak bu koşulları kabul etmiş sayılırsınız.
      </p>

      <h2>1. Taraflar</h2>
      <p>
        Bir tarafta <strong>Sağlayıcı</strong>: {COMPANY.legalName} (bundan sonra "Sağlayıcı"), diğer tarafta
        Hizmet'i kullanan gerçek/tüzel kişi <strong>Kullanıcı</strong> ("Kullanıcı" veya "Siz").
      </p>

      <h2>2. Hizmet Tanımı</h2>
      <p>
        MİLYEMSOFT; kuyumcular ve döviz büroları için canlı Harem Altın kur yayını, POS satış modülü,
        müşteri emanet (Vault) sistemi, cari hesap, envanter, analitik ve AI tabanlı yardımcı araçlar
        sağlayan bir SaaS platformudur. Hizmet, tarayıcı üzerinden erişim ile sunulur.
      </p>

      <h2>3. Üyelik ve Hesap Güvenliği</h2>
      <ul>
        <li>Üyelik için doğru ve güncel bilgi vermek zorunludur.</li>
        <li>Hesap parolanızın gizliliği tamamen sizin sorumluluğunuzdadır; şüpheli erişimi derhal Sağlayıcı'ya bildirin.</li>
        <li>İki faktörlü doğrulama (2FA) kullanmanız güçlü şekilde önerilir.</li>
        <li>Hesabınızdan yapılan tüm işlemlerden Kullanıcı sorumludur.</li>
      </ul>

      <h2>4. 30 Günlük Ücretsiz Deneme</h2>
      <p>
        Yeni kayıt olan her Kullanıcı'ya 30 (otuz) gün ücretsiz deneme süresi tanınır. Deneme süresi boyunca
        kredi kartı bilgisi istenmez; sürenin sonunda ücretli aboneliğe geçilmediği takdirde erişim
        kısıtlanır. Deneme süresi tek seferliktir ve devredilemez.
      </p>

      <h2>5. Ücretlendirme ve Abonelik</h2>
      <ul>
        <li>Fiyatlandırma abonelik sayfasında güncel olarak yayınlanır ve Sağlayıcı tarafından önceden bildirilmek kaydıyla değiştirilebilir.</li>
        <li>Ödemeler PayTR ödeme altyapısı üzerinden alınır. Sağlayıcı, kart bilgilerinizi saklamaz.</li>
        <li>Otomatik yenileme aktifse abonelik, seçilen dönem sonunda otomatik olarak yenilenir. Panelden istediğiniz an iptal edebilirsiniz.</li>
      </ul>

      <h2>6. Kullanım Kuralları</h2>
      <p>Kullanıcı; Hizmet'i şu amaçlarla <strong>kullanamaz</strong>:</p>
      <ul>
        <li>Yasadışı, sahte veya yanıltıcı işlem yapmak.</li>
        <li>Otomatik araç / bot ile toplu veri çekmek (scraping), sistemi yormak.</li>
        <li>Diğer kullanıcıların verilerine izinsiz erişmeye çalışmak.</li>
        <li>Fikri mülkiyet ihlali, telif veya marka ihlali yapmak.</li>
        <li>Hizmet'in bir kopyasını / türevini üretmek, satmak, kiralamak.</li>
      </ul>
      <p>
        Bu kurallara aykırı davranış tespit edilirse Sağlayıcı, hesabınızı önceden haber vermeksizin askıya alabilir veya sonlandırabilir.
      </p>

      <h2>7. Fikri Mülkiyet ve Marka Hakları</h2>
      <p>
        <strong>MİLYEMSOFT®</strong> markası, logosu (MS amblemi), arayüz tasarımı, kaynak kodu,
        veritabanı şeması, canlı Harem Altın kur akış algoritması, POS fiş üretim mantığı,
        AI destekli vitrin/analiz motorları ve platformun tüm alt bileşenlerinin
        <strong> fikri ve sınai mülkiyet hakları münhasıran {COMPANY.legalName} — Mustafa Yıldız</strong>
        'a aittir.
      </p>
      <p>
        Kullanıcı; Hizmet'i satın almış olsa dahi bu haklar üzerinde <strong>hiçbir lisans, kopyalama,
        türev üretim, tersine mühendislik, dekompilasyon ve yeniden dağıtım</strong> hakkına sahip
        değildir. Platform yalnızca abonelik süresince kullanım hakkı sunar — mülkiyet devredilmez.
      </p>
      <p>
        <strong>İzinsiz kullanım, çoğaltma veya taklit girişimleri</strong> 5846 sayılı Fikir ve Sanat Eserleri
        Kanunu, 6769 sayılı Sınai Mülkiyet Kanunu ve 6698 sayılı KVKK kapsamında hukuki + cezai
        yaptırıma tabidir. Sağlayıcı, ihlal tespiti durumunda tazminat ve marka koruma davası açma
        haklarını saklı tutar.
      </p>

      <h2>8. Kullanıcı Verileri ve Yedekleme</h2>
      <p>
        Kullanıcı'nın Hizmet üzerinden yüklediği/oluşturduğu tüm envanter, müşteri, işlem verileri Kullanıcı'nın mülkiyetindedir.
        Sağlayıcı, verileri yalnızca Hizmet'i sunmak amacıyla işler. Haftalık Excel yedek e-postaları otomatik olarak gönderilir;
        Kullanıcı istediği an "Ayarlar → Yedekle" bölümünden manuel yedek indirebilir.
      </p>

      <h2>9. Hizmet Kesintileri</h2>
      <p>
        Sağlayıcı, %99.5 çalışma süresi hedefiyle çalışır. Bakım, altyapı sağlayıcı kesintisi, mücbir sebepler ve
        Harem Altın gibi 3. taraf entegrasyonlarının geçici arızalarından kaynaklı kesintilerde Sağlayıcı sorumluluk kabul etmez.
      </p>

      <h2>10. Sorumluluğun Sınırlandırılması</h2>
      <p>
        Sağlayıcı; dolaylı zararlardan, kâr kayıplarından, kur dalgalanmasından, Kullanıcı hatasından kaynaklı zararlardan sorumlu tutulamaz.
        Sağlayıcı'nın Kullanıcı'ya karşı azami sorumluluğu, son 3 (üç) ayda alınan abonelik ücretiyle sınırlıdır.
      </p>

      <h2>11. KVKK ve Gizlilik</h2>
      <p>
        Kişisel verilerin işlenmesi, KVKK ve GDPR uyumlu politikamıza tabidir. Ayrıntı için
        <a href="/legal/gizlilik-kvkk"> Gizlilik / KVKK Politikası</a> sayfasını inceleyin.
      </p>

      <h2>12. Sözleşme Değişiklikleri</h2>
      <p>
        Sağlayıcı, bu Kullanım Koşulları'nı gerektiğinde güncelleyebilir. Önemli değişikliklerde Kullanıcı'ya e-posta ile bilgi verilir.
        Güncellenmiş metnin yayınlanmasından sonra Hizmet'i kullanmaya devam etmek yeni metnin kabulü anlamına gelir.
      </p>

      <h2>13. Uygulanacak Hukuk ve Yetkili Mahkeme</h2>
      <p>
        İşbu Koşullar Türkiye Cumhuriyeti hukukuna tabidir. Uyuşmazlıklarda <strong>Hatay Mahkemeleri ve İcra Daireleri</strong> yetkilidir.
        Tüketici uyuşmazlıkları için Tüketici Hakem Heyetleri de yetkilidir.
      </p>

      <h2>14. İletişim</h2>
      <p>
        Bu Koşullar hakkında sorularınız için: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> ·
        Telefon: {COMPANY.phone} · Adres: {COMPANY.address}
      </p>
    </LegalLayout>
  );
}
